import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import { composeUrl } from 'app/core/shared/helper/url.helper';
import {
    Mawop,
    MawopCalculator,
    PaginateResponse,
    Response,
    OptionItem
} from 'app/modules/equipment-registration/model/mawop.model';
import { getFormattedDateTime } from 'app/core/shared/helper/date.helper';

@Injectable({ providedIn: 'root' })
export class MawopService {
    constructor(private _httpClient: HttpClient) {}

    getMawopList(params: any): Observable<Response<PaginateResponse<Mawop>>> {
        const url = composeUrl(`/v1/Mawop/MawopList`, params);
        return this._httpClient
            .get<Response<PaginateResponse<Mawop>>>(url)
            .pipe(take(1));
    }

    getMawop(id: string): Observable<Response<Mawop>> {
        const url = composeUrl(`/v1/Mawop/${id}`);
        return this._httpClient.get<Response<Mawop>>(url).pipe(take(1));
    }

    getMawopCalculator(mawopId: string): Observable<Response<MawopCalculator>> {
        const url = composeUrl(`/v1/Mawop/CalculatorData/${mawopId}`);
        return this._httpClient
            .get<Response<MawopCalculator>>(url)
            .pipe(take(1));
    }

    createMawop(payload: Mawop): Observable<any> {
        const url = composeUrl(`/v1/Mawop`);
        return this._httpClient.post<any>(url, payload);
    }

    updateMawop(payload: Mawop): Observable<any> {
        const url = composeUrl(`/v1/Mawop`);
        return this._httpClient.put<any>(url, payload);
    }

    deleteMawop(mawopCalculatorId: string): Observable<Response<any>> {
        const url = composeUrl(`/v1/Mawop`, { mawopCalculatorId: mawopCalculatorId});
        return this._httpClient.delete<Response<any>>(url).pipe(take(1));
    }

    computeMawop(payload: MawopCalculator): Observable<any> {
        const url = composeUrl(`/v1/Mawop/ComputeMawop`);
        return this._httpClient.post<any>(url, payload);
    }

    downloadExcel(url: string) {
        const { date, time } = getFormattedDateTime();
        
        this._httpClient
            .get(url, { responseType: 'blob' })
            .subscribe((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `Casing_Scheme_Data_${date}_${time}.xlsx`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            });
    }

    getMawopCasing(): Observable<Response<OptionItem[]>> {
        const url = composeUrl(
            `/v1/Option/GetOptionItems?mdOptionName=md_mawop_casing`
        );
        return this._httpClient.get<Response<OptionItem[]>>(url).pipe(take(1));
    }
}
